import React, { useContext, useMemo } from 'react';
import moment from 'moment';

import { InvoiceContext } from 'components/pages/finance/NewInvoice/NewInvoiceContext';

import { DD_SLASH_MMM_SLASH_YYYY } from '../../../../../../constants/dateFormat';

import { normalizeInvoiceGroups } from './encounterInvoiceTemplateUtils';
import { InvoicePageGenerator } from './InvoicePageGenerator';

export const EncounterInvoiceTemplate = ({
  invoices,
  invoiceNumber,
  comment,
  terms,
  payee,
  contact,
  investigator,
  remit,
  balanceDue,
  paymentsCredits,
  totalPages,
  setTotalPages,
  billTo,
  invoiceType,
  adjustmentDate,
  invoiceDate
}) => {
  const { includeAdjustments } = useContext(InvoiceContext);

  const normalizedGroups = useMemo(
    () =>
      normalizeInvoiceGroups(invoices, {
        comment,
        balanceDue,
        paymentsCredits,
        includeAdjustments,
        invoiceType
      }),
    [invoices, balanceDue, comment, paymentsCredits, includeAdjustments, invoiceType]
  );

  const invoiceDateForPdf = useMemo(() => {
    if (invoiceDate) {
      return moment(invoiceDate).format(DD_SLASH_MMM_SLASH_YYYY);
    }
    if (adjustmentDate) {
      return moment(adjustmentDate).format(DD_SLASH_MMM_SLASH_YYYY);
    }
    return moment().format(DD_SLASH_MMM_SLASH_YYYY);
  }, [adjustmentDate, invoiceDate]);

  return (
    <InvoicePageGenerator
      normalizedGroups={normalizedGroups}
      pageNumber={1}
      totalPages={totalPages}
      setTotalPages={setTotalPages}
      study={invoices?.[0]?.studyName}
      pcn={invoices?.[0]?.pcnName}
      investigator={investigator}
      site={invoices?.[0]?.siteName}
      siteNumber={invoices?.[0]?.siteNumber}
      invoiceNumber={invoiceNumber}
      invoiceDate={invoiceDateForPdf}
      terms={terms}
      payee={payee}
      contact={contact}
      remit={remit}
      billTo={billTo}
      invoiceType={invoiceType}
    />
  );
};
